import { FaGithub } from "react-icons/fa";
import LightWave from "../Waves/LightWave";
import "./ProjectDark.css";
import frontedmasters_pic from "../../images/weatherApp.png";

function Project2() {
  return (
    <article className="project dark">
      <div className="project__main">
        <div data-aos="fade-right" className="project__left">
          <h3 className="project__title project__titleDark">
            Weather App
          </h3>
          <p className="project__description project__body">
            A Weather app in which user can Search and get weather information of
            particular place.

          </p>
          <p className="project__tech project__body">
            &gt;Javascript · React.js
          </p>
          <div className="code_url_div">
          <a
            className="project__sourceCodeDark"
            href="https://github.com/Keshav-babu/ReactWeather-CounterApp"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="=Website GitHub Repository"
          >
            <FaGithub className="project__githubLogo" size={25} />
            <h3 className="project__sourceCodeText">Source Code</h3>
          </a>
          <a
            className="project__sourceCodeDark"
            href="https://react-weather-counter-app-4xcaw5x3s-keshav-babu.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="=Website GitHub Repository"
          >
            <FaGithub className="project__githubLogo" size={25} />
            <h3 className="project__sourceCodeText">View Project</h3>
          </a>
          </div>
          {/* <a
            className="project__sourceCodeDark"
            href="https://github.com/Keshav-babu/terminal-poerfolio.git"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="=Website GitHub Repository"
          >
            <FaGithub className="project__githubLogo" size={25} />
            <h3 className="project__sourceCodeText">Source Code</h3>
          </a> */}
        </div>
        <img
          className="project__image project__imageDark"
          src={frontedmasters_pic}
          srcset={frontedmasters_pic}
          sizes="50vw"
          alt="Covid Bot Project Commands"
          width="50%"
          height="auto"
          loading="lazy"
        />
      </div>
      <LightWave />
    </article>
  );
}

export default Project2;
